import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ModalTagsManager from './ModalTagsManager'
import { actions, types } from '../../../store'

const mapStateToProps = state => ({
  status: state.modal.tagsModal.status,
  fetching: state.tag.isFetching,
  list: state.tag.list
})

const mapDispatchToProps = dispatch => bindActionCreators({
  close: () => actions.modal.setModal(types.MODAL_TAGS, { status: false }),
  getTags: actions.tag.getTags,
  createTag: actions.tag.createTag,
  editTag: actions.tag.editTag,
  deleteTag: actions.tag.deleteTag,
  getStorage: actions.storage.getStorage
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalTagsManager)



// WEBPACK FOOTER //
// ./src/components/Modals/ModalTagsManager/index.js